export const getBodyBlockWithId = <T extends { id: string }>(
  body: { blocks?: T[] } | undefined,
  id: string,
): T | undefined => body?.blocks?.find((block) => block.id === id);
